<template>
	<div class="class_select_list_header">
		<div class="class_name_content1" :class="(item.class_id == current_class && show_detail) ? 'class_name_content_select' : 'class_name_content'" v-for="item in all_date" :key="item.class_id">

			<!-- <img :src='(item.class_id == current_class && show_detail) ? "https://resources.xycoder.com/dowa/images/arrow_down.png" : "https://resources.xycoder.com/dowa/images/arrow_up.png" ' alt=""> -->
			<div id="class_name" @click="class_click(item)">{{item.class_name}}</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
	import store from '@/store/index.js';

	export default{
        name:"classSelectListHeader",
        props: {
            show_detail: {
                type: Boolean,
                default: true
            }
        },
		data(){
			return{
				current_class: null,
				current_class_date: null,
				all_date:null
			}
		},

		computed:{
			allProductDate(){
				return store.state.product_data;
			}
		},
		mounted() {
			this.current_class = this.$route.params.class;
			var product_id = this.$route.params.id;
			if (!this.current_class && product_id) {
				var alldate = this.all_date
				if (!alldate) {
					return
				}
				alldate.forEach(product_class => {
					var products = product_class.products
					products.forEach(product => {
						console.log(product)
						if (product.product_id == product_id) {
							this.current_class = product.product_class_id
						}
					});
				});
			}
			// console.log('路由传参：' + this.current_class);
			// console.log(product_id);
			// store.state.product_data = store.state.product_data;
		},
		methods:{
			class_click(item){
				// console.log(item.class_name);
                this.$router.push({name:'productClass',params:{class:item.class_id}});
                this.$emit('classClickBlock', item);
                
			},
			product_click(list){
                // console.log(list.product_name);
                this.$router.push({name:'productinfo',params:{id:list.product_id}});
                this.$emit('productClickBlock', list);
			}
		},
		watch:{
			$route(){
				this.current_class = this.$route.params.class;
			},
			allProductDate:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					// console.log('开始监听');
					//  console.log(newValue);
					//  console.log(oldValue);
					if (newValue == null || newValue.classes == null) {
						return
					}
					 this.all_date = newValue.classes;
				 }
			}
		}
	}

</script>

<style type="text/css" scoped>
	.product_class{
		margin-top: 50px;
    }
    .class_select_list_header{
        margin: 10px;
        padding-top: 10px;
        flex-flow: row wrap;
        align-content: flex-start;
        white-space: nowrap;
        /* overflow: scroll; */
        overflow-y: hidden;
        overflow-x: auto;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
    }
    .class_select_list_header::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
    .class_name_content1{
        display: inline-block;
        flex: 30%;
        width: 20vw;
        overflow-x: auto;
        height: 110%;
        margin-left: 10px;
        position: relative;
        background-position: center;
        background-size: 20vw 20vw;
        background-repeat: no-repeat;
    }
    .class_name_content{
		/* border-top:1px solid gray; */
		/* background: red; */
        /* display: flex; */
        background-image: url(https://resources.xycoder.com/dowa/images/class_unselected.png);
    }
    
	.class_name_content_select{
		/* border-top:1px solid gray; */
        /* background: green; */
        background-image: url(https://resources.xycoder.com/dowa/images/class_selected.png);
    }
    #class_name{
        color: white;
        line-height: 40px;
        line-height: 20vw;
        position: relative;
        display: inline-block;
        text-align: center;
        width: 100%;
    }

	#class_name img{
		float: right;
		padding-top: 14px;
		padding-right: 15px;
		width: 15px;
		height: 9px;
	}
</style>


// WEBPACK FOOTER //
// src/components/ClassSelectListHeader.vue